/* cji-gallery-count, 19 September 2026.

   Jamie, from a Clarity session on a PAID click: "Only 1 image". The product
   had four photos. The gallery is a Swiper with working arrows and nothing
   else: no dots, no thumbnails, no counter. So it reads as a single photo and
   the arrows read as decoration, and a visitor who arrived on an ad saw a
   quarter of what we have.

   This adds the cheapest possible signal, "1 / 4" in the corner of the frame.
   Not dots: the letter pieces carry up to 38 photos and a row of 38 dots is
   worse than nothing.

   WHICH SWIPER. A product page carries up to three and two of them are
   related product rows. The gallery is the one holding ul.l4pr, the Xtra
   theme's photo list, the same handle cji-gallery-track.js uses. The related
   rows are ul.l4cl and the recently viewed aside is another. Keyed on the
   markup rather than on a[data-fancybox], which was the first attempt: the
   lightbox is initialised by the theme's own JS, so keying on it is a race
   this script can lose on a slow load.

   The personalizer templates render no l4pr at all, they present their photos
   another way, so those pages get no counter and want none.

   It must never cost the shopper anything, same discipline as
   cji-gallery-track.js: everything wrapped, no dependency on the theme's
   Swiper instance, and if it throws the shopper still gets a working gallery
   and simply no counter. */
(function () {
  'use strict';
  try {
    if (!/\/products\//.test(location.pathname)) return;

    var CLS = 'cji-gal-count';

    function paint(outer) {
      try {
        var slides = outer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
        var total = slides.length;
        var el = outer.querySelector('.' + CLS);
        /* One photo needs no counter, and saying "1 / 1" invites the reader to
           look for a second one. */
        if (total < 2) { if (el) el.remove(); return; }
        var cur = 0;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].className.indexOf('swiper-slide-active') > -1) { cur = i; break; }
        }
        if (!el) {
          el = document.createElement('span');
          el.className = CLS;
          outer.appendChild(el);
        }
        /* cji-gal-count-noloop, 15 October 2026. Write only when the text
           changes. Setting textContent replaces the text node, the body
           observer below sees that as a DOM change and runs init again 120ms
           later, which wrote the same text again: about 8 rewrites a second on
           every product page, forever. Found in Clarity session 3r3oim, whose
           replay showed the counter as "4 / 42 / 41 / 41 / 41 / 4". */
        var txt = (cur + 1) + ' / ' + total;
        if (el.textContent !== txt) el.textContent = txt;
      } catch (e) { /* a counter is not worth a broken page */ }
    }

    function init() {
      try {
        var outers = document.querySelectorAll('.swiper-outer');
        for (var i = 0; i < outers.length; i++) {
          var o = outers[i];
          /* closest, not querySelector: the swiper sits INSIDE ul.l4pr, so
             l4pr is an ancestor of it and not a descendant. Searching
             downwards matched nothing and removed the counter from every
             page. */
          if (!o.closest('ul.l4pr')) continue;   /* l4cl rows are related products */
          paint(o);
          if (o.getAttribute('data-cji-counted')) continue;
          o.setAttribute('data-cji-counted', '1');
          /* No Swiper instance needed. The active slide is marked with a class,
             so watching the class is enough and works whatever version the
             theme ships or how it wraps the constructor. */
          var mo = new MutationObserver(function (recs) {
            paint(recs[0].target.closest('.swiper-outer') || o);
          });
          var wrap = o.querySelector('.swiper-wrapper') || o;
          mo.observe(wrap, { attributes: true, attributeFilter: ['class'], subtree: true });
        }
      } catch (e) { /* as above */ }
    }

    /* The theme swaps the whole product section on a variant change, which
       takes the counter with it, so re-run when the DOM settles rather than
       only once on load. */
    var t = null;
    function schedule() { clearTimeout(t); t = setTimeout(init, 120); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else { schedule(); }
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* as above */ }
})();
